/** @jsxImportSource @emotion/react */
import { Team } from '../../../../domain/intefaces';
import Advertisement from '../../../components/board/advertisement';
import Header from '../../../components/board/header';
import Period from '../../../components/board/period';
import Score from '../../../components/board/score';
import Timer from '../../../components/board/timer';
import TMLabel from '../../../components/tm-label';
import { LabelCss, MainBlock } from './styles';

interface IProps {
  teams: [Team, Team];
  period: number;
  time: number;
  roundTo: 'floor' | 'ceil';
}

function Tablet(props: IProps) {
  const { teams, period, time, roundTo } = props;

  return (
    <MainBlock>
      <Header value="ПРИВЕТСТВУЕМ УЧАСТНИКОВ ИГРЫ" />
      <div id="body" className="flex-center flex-col">
        <div id="upper" className="flex flex-row">
          <Score id={'score'} score={teams[0].score} teamName={teams[0].name} />
          <Period id="period" value={period} />
          <Score id={'score'} score={teams[1].score} teamName={teams[1].name} />
        </div>
        <div id="center" className="flex-center flex flex-col">
          <Timer id="timer" milliseconds={time} roundTo={roundTo} />
          <TMLabel id="label" css={LabelCss} fontSize={62} />
        </div>
      </div>
      <Advertisement />
    </MainBlock>
  );
}

export default Tablet;
